export default function VideoIcon({}) {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.0532 10.5174L10.8556 8.98152L19.1213 6.71955C19.529 6.60797 19.7711 6.17964 19.6619 5.76284L19.2947 4.36084C19.1856 3.94405 18.7665 3.69662 18.3588 3.80821L8.63559 6.46903L8.22159 5.77356L18.1611 3.05354C18.9766 2.83038 19.8147 3.32522 20.033 4.1588L20.4002 5.56081C20.6185 6.39439 20.1344 7.25105 19.3189 7.47422L11.0532 9.73619H18.7071C19.9734 9.73619 21 10.7855 21 12.0799L21 16.6563C21 17.9507 19.9734 19 18.7071 19H16.095L15.6299 18.2188H18.7071C19.5513 18.2188 20.2357 17.5192 20.2357 16.6563L20.2357 12.0799C20.2357 11.217 19.5513 10.5174 18.7071 10.5174H11.0532ZM14.6391 18.2188H14.6958L15.1609 19H15.0987L16.2067 20.8835L15.3447 21.3906L13.9385 19H5.71423C4.44791 19 3.42136 17.9507 3.42136 16.6563L3.42136 12.0799C3.42136 11.8764 3.43319 11.6711 3.44502 11.4657C3.47241 10.9901 3.49983 10.5141 3.38064 10.059L3.05238 8.80566C2.83406 7.97208 3.31816 7.11542 4.13365 6.89226L6.44435 6.25992L5.34473 4.39057L6.20666 3.88354L14.6391 18.2188ZM13.479 18.2188L6.85412 6.95654L4.3313 7.64692C3.92356 7.7585 3.68151 8.18684 3.79067 8.60363L4.11893 9.85699C4.23334 10.2938 4.24089 10.721 4.22886 11.0871C4.22288 11.2691 4.21405 11.4158 4.20593 11.5508C4.19517 11.7297 4.18565 11.8879 4.18565 12.0799V16.6563C4.18565 17.5192 4.87002 18.2188 5.71423 18.2188L13.479 18.2188Z"
          fill="white"
        />
      </svg>
    </>
  );
}
